export default __webpack_public_path__ + "static/media/small_avatar.0cdd4fad.svg";